import { IMaintenanceForms } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions, Not, Equal } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/maintenance_forms';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  select: [
    'id',
    'name',
    'email',
    'unit',
    'workOrder',
    'category',
    'details',
    'priority',
    'isProcessed',
    'created',
    'followUpSent',
    'modified',
    'maintenanceFormBuilding.id',
    'maintenanceFormBuilding.buildingName',
    'city.cityName',
    'province.provinceCode',
    'status',
  ],
  relations: [
    {
      path: 'maintenanceFormBuilding',
      alias: 'maintenanceFormBuilding',
    },
    {
      path: 'maintenanceFormBuilding.city',
      alias: 'city',
    },
    {
      path: 'city.province',
      alias: 'province',
    },
  ],
  where: [
    Not(Equal('status', 'deleted')),
  ],
};

const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'maintenanceFormBuilding',
      alias: 'maintenanceFormBuilding',
    },
    {
      path: 'maintenanceFormBuilding.city',
      alias: 'maintenanceFormCity',
    },
    {
      path: 'maintenanceFormCity.province',
      alias: 'province',
    },
    {
      path: 'form',
      alias: 'form',
    },
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IMaintenanceForms>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'maintenance/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
